<template>
    <home endpoint="farerule" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'farerule',
  components: {
    home,
  },
  data () {
    return {
      params: {
        fields: [
          {name: 'id', hidden: true},
          {name: 'Name', label: 'Nombre'},
          {name: 'ProductClassId', label: 'Producto', editor: 'select', required: true,
              relation: 'productclass', optionLabels: 'Name'},
          {name: 'MarketType', label: 'Mercado', editor: 'select', required: true, defValue: 0,
              options: [
                    {value: 0, label: 'Local'},
                    {value: 1, label: 'Internacional'},
                    ]},
          {name: 'AdvancePurchaseValue', label: 'AP (valor)', editor: 'number'},
          {name: 'AdvancePurchaseUnit', label: 'AP (unidad)', editor: 'select', defValue: 1,
              options: [
                    {value: 0, label: 'Horas'},
                    {value: 1, label: 'Días'},
                    ]},
          {name: 'RefundAllowed', label: 'Permite devolución', editor: 'checkbox'},
          {name: 'CancellationFeeCode', relation: 'fee', optionLabels: 'Name',
                editor: 'select', label: 'Cargo cancelación', id: 'FeeCode', addBlank: true},
          {name: 'DateChangeAllowed', label: 'Permite cambio de fecha', editor: 'checkbox'},
          {name: 'DateChangePenaltyFeeCode', relation: 'fee', optionLabels: 'Name',
                editor: 'select', label: 'Cargo penalidad cambio', id: 'FeeCode', addBlank: true},
          {name: 'SeatSelectionIncluded', label: 'Incluye selección de asientos', editor: 'checkbox'},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'},
          {name: 'IncludedSSRs', editor: [], hideFromList: true, label: 'SSR incluidos',
            rowFields: [
                {name: 'SSRCode', relation: 'ssr', optionLabels: 'Name',
                    editor: 'select', label: 'SSR', id: 'SSRCode', required: true, columns: 8},
                {name: 'Quantity', label: 'Cantidad', editor: 'number', required: true, defValue: 1, columns: 2},
            ]},
          {name: 'IncludedSeatZones', editor: [], hideFromList: true, label: 'Zonas de asiento incluidas',
            rowFields: [
                {name: 'ZoneCode', relation: 'seatzone', optionLabels: 'Name',
                    editor: 'select', label: 'Zona', id: 'ZoneCode', required: true},
            ]},
          ],
        title: 'Reglas Tarifarias',
        title2: 'Regla Tarifaria',
      }
    }
  },
}
</script>
